<template>
  <div class="userCenter">
    <div class="userInfo">
      <img :src="'../../../static/images/user/ico'+ userInfo.Level +'.png'"/>
      <span class="name">{{userInfo.Name || '未知'}}</span>
      <span>{{userInfo.Telephone}}</span>
    </div>
    <div class="userBtns">
      <div class="btnItem" @click="goWallet">
        <div class="left">
          <img src="@/assets/images/user/walletIcon.png"/>
          <span>我的钱包</span>
        </div>
        <div class="right">
          <span>可提现</span>
          <img src="@/assets/images/user/rightArrow.png"/>
        </div>
      </div>
      <div class="btnItem" @click="goSeeting">
        <div class="left">
          <img src="@/assets/images/user/setUpIcon.png"/>
          <span>个人设置</span>
        </div>
        <div class="right">
          <span>银行卡</span>
          <img src="@/assets/images/user/rightArrow.png"/>
        </div>
      </div>
      <!--<div class="btnItem">-->
        <!--<div class="left">-->
          <!--<img src="@/assets/images/user/helpIcon.png"/>-->
          <!--<span>客服中心</span>-->
        <!--</div>-->
        <!--<div class="right">-->
          <!--<span>常见问题人工客服</span>-->
          <!--<img src="@/assets/images/user/rightArrow.png"/>-->
        <!--</div>-->
      <!--</div>-->
      <div class="quitBtn" @click="removeToken">退出登录</div>
    </div>

    <div class="goDaFang" v-if="deviceType==2.5" @click="goDaFang">
      <img src="@/assets/images/user/goDaFang.png"/>
    </div>
  </div>
</template>
<script>
import { getCurrentMemberInfo } from "@/utils/api";
import { deviceType } from "@/utils/env";
export default {
  name: "userCenter",
  data() {
    return {
      userInfo: {
        Name: "姓名",
        Telephone: ""
      },
      deviceType: deviceType
    };
  },
  created() {
    this.getDeviceType();
  },
  mounted() {
    this.initData();
  },
  methods: {
    async getDeviceType () {
      if(this.deviceType=2.5){
        // 微信小程序
      } else {
        let userAgent = navigator.userAgent;
        if (/MicroMessenger/.test(userAgent)) { //微信客户端
          this.deviceType = 2;
          this.orderSource = 9;
          wx.miniProgram.getEnv(res => {
            if (res.miniprogram) {
              this.deviceType = 2.5;
              console.log("在小程序里")
            } else {
              console.log("不在小程序里")
            }
          })
        }
      }
    },
    async initData() {
      let res = await getCurrentMemberInfo();
      if (res.Code == 100) {
        this.userInfo = res.Data;
        localStorage.setItem("userInfo", JSON.stringify(res.Data));
      }
    },
    goWallet() {
      this.$router.replace({ path: "/wallet" });
    },
    goSeeting() {
      this.$router.replace({ path: "/personalSetting" });
    },
    removeToken() {
      this.flexible.confirm({
        title: "提示",
        content: "确认退出登录？",
        confirmButtonText: "确定",
        success: res => {
          window.localStorage.removeItem("token");
          if(this.deviceType!=2.5 ){
            wx.miniProgram.reLaunch({url:"index"});
            wx.miniProgram.postMessage({ data: { type: 'loginOut' } });
          }else{
            this.$router.replace({ path: "/index" });
          }
        }
      });
    },
    goDaFang () {
      if( this.deviceType==2.5 ){
        let _token = localStorage.getItem("token") || '';
        wx.miniProgram.reLaunch({url:"index?redirect_uri=/userCenter"});
        wx.miniProgram.postMessage({ data: {type: 'goDaFang', token: _token} });
      }
    }
  }
};
</script>
<style scoped lang="scss" type="text/scss">
.userCenter {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 110px;
  box-sizing: border-box;
  background: url("~@/assets/images/user/userBg.png") no-repeat 0 0;
  background-size: 100% 270px;
  .userInfo {
    display: flex;
    align-items: center;
    height: 80px;
    padding-bottom: 32px;
    img {
      width: 80px;
      height: 80px;
      border-radius: 50%;
      margin-left: 76px;
    }
    span {
      font-size: 26px;
      color: #fff;
    }
    span.name {
      margin: 0 56px 0 25px;
    }
  }
  .userBtns {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 0 70px;
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    background: #fff;
    .btnItem {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 36px 0;
      border-bottom: 1px solid #dcdcdc;/*no*/
      .left {
        display: flex;
        align-items: center;
        img {
          width: 48px;
          height: 48px;
        }
        span {
          font-size: 28px;
          color: #000;
          margin-left: 14px;
        }
      }
      .right {
        display: flex;
        align-items: center;
        span {
          font-size: 24px;
          color: #9f9f9f;
        }
        img {
          width: 32px;
          height: 32px;
          margin-left: 14px;
        }
      }
    }
    .quitBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 90px;
      margin-top: 70px;
      font-size: 28px;
      box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
      -webkit-box-shadow: 0 0 6px rgba(0, 0, 0, 0.16);
      opacity: 1;
      border-radius: 6px;
    }
  }
  .goDaFang {
    position: absolute;
    left: 0;
    bottom: 60px;
    width: 100%;
    box-sizing: border-box;
    padding: 0 70px;
    img { width: 100%; }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/user/userCenter.vue